"use client";

import ProductInfo from "./ProductInfo";
import ProductSpecifics from "./ProductSpecifics";
import ProductSections from "./ProductSections";
import RelatedProducts from "./RelatedProducts";
import { useEffect, useState } from "react";
import CommonFaqs from "@/components/common/CommonFaqs";
import ProductOptionPills from "./ProductOptionPills";
import ProductInfoTabs from "./ProductInfoTabs";
export default function ProductPageAsync({
  product,
  faqs = [],
  shippingPolicyHtml,
  refundPolicyHtml,
  labelMap,
  labels
}) {
  const [extras, setExtras] = useState(null);
  const [loading, setLoading] = useState(false);
  const defaultVariant = product?.variants?.[0];
  const [selectedVariant, setSelectedVariant] = useState(defaultVariant);
  const [selectedOptions, setSelectedOptions] = useState(defaultVariant?.option_values || {});
  const [quantity, setQuantity] = useState(1);
  useEffect(() => {
    if (!product.handle) return;
    let ignore = false;
    async function fetchData() {
      try {
        setLoading(true);
        const res = await fetch(`/api/productsections/${product.handle}`);
        const json = await res.json();
        if (!ignore) {
          setExtras(json);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    }
    fetchData();
    return () => {
      ignore = true;
    };
  }, [product.handle]);
  return <>
            <section className={'bg-gray-50 py-4 lg:py-6'}>
                <div className={'max-w-7xl mx-auto px-2'}>
                    <ProductInfo product={product} labels={labels} labelMap={labelMap} addons={extras?.addons} selectedVariant={selectedVariant} setSelectedVariant={setSelectedVariant} selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} quantity={quantity} setQuantity={setQuantity} />
                </div>
            </section>
            {/*<ProductHighlights product={product}/>*/}
            <section className={'bg-gray-50 pt-4'}>
                <div className={'max-w-7xl mx-auto px-2'}>
                    <div className={'grid grid-cols-1 gap-y-3'}>
                        {/*<ProductDescription product={product}/>*/}
                        <ProductInfoTabs product={product} shippingPolicyHtml={shippingPolicyHtml} refundPolicyHtml={refundPolicyHtml} />
                        <ProductOptionPills product={product} selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} setSelectedVariant={setSelectedVariant} setQuantity={setQuantity} />
                        <ProductSpecifics product={product} />
                    </div>
                </div>
            </section>
            <ProductSections sections={extras?.sections} labelMap={labelMap} />

            <CommonFaqs faqs={faqs} subtext={`Common questions about ${product?.title}`} />

            {/*<ReviewSection*/}
            {/*    product={product}*/}
            {/*/>*/}

            <RelatedProducts products={extras?.related_products} labelMap={labelMap} />
        </>;
}